const getProductHighlightListResponse = (response) => {
  const productVariants = response?.data?.productVariants ?? [];
  return {
    data: productVariants.map((v) => ({
      id: v.id,
      image: v.imagePath,
      productName: v.productName,
      isPrimary: v.isPrimary,
      skuCode: v.sku || '-',
      magpieCode: v.magpieCode || '-',
      erpCode: v.sapCode || '-',
    })),
    totalPage: response?.data?.totalPage ?? 1,
  };
};

export default getProductHighlightListResponse;
